exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__TableStatus__root {\n  display: inline-block;\n  padding: 6px 8px;\n  border-radius: 8px;\n}\n\n.DS__TableStatus__type_warning {\n    background-color: #fff4e9;\n  }\n\n.DS__TableStatus__type_ghost {\n    background-color: #eceff5;\n  }\n\n.DS__TableStatus__text {\n  text-transform: uppercase;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__TableStatus__root",
	"type_warning": "DS__TableStatus__type_warning",
	"type_ghost": "DS__TableStatus__type_ghost",
	"text": "DS__TableStatus__text"
};